export default function SectionApp() {
  return (
    <section id="app" className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-4">
              移动观影
            </h2>
            <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-6">
              无需下载应用程序，手机浏览器打开即可畅享<strong className="text-primary-400 font-medium">高清免费在线观看</strong>体验。全面适配各类移动设备，支持全面屏、折叠屏，流量优化技术帮你在移动网络下也能<strong className="text-secondary-400 font-medium">秒开无卡顿</strong>地观看喜欢的电影电视剧。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-200/60 border border-background-300/30 cursor-pointer hover:border-primary-500/30 transition-colors">
                <i className="ri-smartphone-line text-primary-400 text-lg"></i>
                <span className="text-sm text-foreground-300">手机浏览器访问</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-200/60 border border-background-300/30 cursor-pointer hover:border-primary-500/30 transition-colors">
                <i className="ri-tablet-line text-secondary-400 text-lg"></i>
                <span className="text-sm text-foreground-300">平板适配</span>
              </div>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
              {['不缓冲播放', '高清画质', '流量优化', '全屏适配'].map((feat, i) => (
                <span key={i} className="flex items-center gap-1.5 text-xs text-foreground-400">
                  <i className="ri-check-line text-primary-400"></i>
                  {feat}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="relative w-[180px] h-[360px] md:w-[200px] md:h-[400px] rounded-2xl overflow-hidden border-2 border-background-300/40 bg-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20movie%20streaming%20interface%20on%20dark%20screen%2C%20film%20poster%20thumbnails%2C%20clean%20modern%20UI%20design%2C%20warm%20golden%20accent%20colors%2C%20minimal%20layout%2C%20no%20text%20on%20screen&width=300&height=600&seq=app-chunse-01&orientation=portrait"
                alt="春色影视移动端观影界面"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}